module.exports = __webpack_public_path__ + "static/media/emoji_2.7de28082.svg";